import { useState, useEffect } from 'react';

const tools = [
  'Gist Images',
  'Gist Speech',
  'Gist Blog',
];

export default function RotatingToolBadge() {
  const [currentTool, setCurrentTool] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTool((prev) => (prev + 1) % tools.length);
    }, 2000); // Change every 2 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <span className="px-2 py-0.5 text-xs font-semibold bg-primary-500 text-white rounded animate-fade-in">
      {tools[currentTool]}
    </span>
  );
}

